var map = {
	"./icon-arrow-down.svg": "9435",
	"./icon-arrow-left.svg": "9ac8",
	"./icon-arrow-right.svg": "212f",
	"./icon-calendar.svg": "c4e4",
	"./icon-check.svg": "8821",
	"./icon-delete.svg": "11ca",
	"./icon-moon.svg": "ae99",
	"./icon-plus.svg": "77ea",
	"./icon-sun.svg": "2021",
	"./illustration-empty.svg": "dfd3",
	"./image-avatar.jpg": "2a49",
	"./logo-desktop.svg": "cd31",
	"./logo.svg": "e347"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";